<template>
  <div class="visit-inspection-form-view">
    <VisitInspectionForm
      v-show="inspectionStore.formLoaded"
      :mode="formMode"
      :visitId="visitId"
      :menuUserRole="menuUserRole"
      :type="type"
      :isEmailLink="isEmailLink"
    />
    <VisitInspectionFormSkeleton v-show="!inspectionStore.formLoaded" />
  </div>
</template>

<script setup lang="ts">
import VisitInspectionForm from "./VisitInspectionForm.vue";
import { EnumVisitMode } from "@/Domain/EnumVisitMode";
import { useInspectionStore } from "@/stores/useInspectionStore";
import VisitInspectionFormSkeleton from "./VisitInspectionFormSkeleton.vue";
import { CacheService } from "@/shared/services/CacheService";
import { useQueryParams } from "@/shared/helpers/useQueryParams";

const inspectionStore = useInspectionStore();

const { getParam } = useQueryParams();
const formMode = getParam("mode") as "new" | "view";
let visitId = getParam("visitID") as string;
const savedVisitId = CacheService.get("RfrVisitInspectionFormId", () => "");
if (!visitId && savedVisitId) {
  visitId = savedVisitId;
  inspectionStore.hideVisitId = true;
}

const menuUserRole = getParam("menu", "VisitsAsRfr");
const type = EnumVisitMode[getParam("type", EnumVisitMode.Inspection) as keyof typeof EnumVisitMode];
const isEmailLink = getParam("emailLink")?.toLowerCase() == "y";
</script>

<style scoped lang="scss">
.visit-inspection-form-view {
  padding: 4px;
  display: flex;
  flex-direction: column;
  margin: 30px auto 0;
  width: 100%;
  max-width: 900px;

  // Desktop: increase max-width to accommodate sidebar (280px) + gap (20px) + original form width (900px)
  @include media-breakpoint-up(lg) {
    max-width: 1200px;
  }

  &__header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: wrap-reverse;
  }
}

.page__header-status {
  color: #73090b;
  font-weight: bold;
  margin-top: 20px;
  display: inline-block;
  font-size: 16px;
}
</style>
